module.exports = __webpack_public_path__ + "static/media/fc.65d6a524.png";